import './DatePicker.css';
import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { addDays } from "date-fns";
import { ar, ru, cs, nl, fi, de, ja, nb, pt, sv, zhCN, da, fr, it, ko, pl, ro, es, uk, tr, enUS } from 'date-fns/locale';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
const langHash = {
  ar: ar,
  ru: ru,
  cs: cs,
  nl: nl,
  fi: fi,
  de: de,
  ja: ja,
  no: nb,
  pt: pt,
  sv: sv,
  zh: zhCN,
  da: da,
  fr: fr,
  it: it,
  ko: ko,
  pl: pl,
  ro: ro,
  es: es,
  uk: uk,
  tr: tr,
  en: enUS
};
const getStringFullDate = date => date.toLocaleString(undefined, {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
});
const getStringWeek = (date, lang) => date.toLocaleString(lang ? langHash[lang] : undefined, {
  weekday: 'long'
});
const emptyDateShowObj = {
  day: '',
  dayNumber: '',
  month: '',
  monthNumber: '',
  year: '',
  fullDate: new Date()
};
const DatePickerDropDown = _ref => {
  let {
    lang,
    rtl,
    dateOpened,
    closeDateDropdown,
    closeDateDropdownWithAnalytics,
    setDepDate,
    isMobile,
    dateMobileDateText,
    changeWeatherDataHandler
  } = _ref;
  const [singleDate, setSingleDate] = useState(new Date());
  const renderCustomHeader = props => {
    const {
      monthDate,
      decreaseMonth,
      increaseMonth,
      nextMonthButtonDisabled,
      prevMonthButtonDisabled
    } = props;
    return /*#__PURE__*/React.createElement("div", {
      className: "react-datepicker__header-month"
    }, /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__current-month"
    }, monthDate.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
      month: "long",
      year: "numeric"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Previous Month",
      className: `
          react-datepicker__navigation react-datepicker__navigation--previous
          ${isMobile ? 'd-none' : ''}
          ${prevMonthButtonDisabled ? 'd-none' : ''}
        `,
      onClick: decreaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowLeft, {
      className: "icon"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Next Month",
      className: `
          react-datepicker__navigation react-datepicker__navigation--next
          ${isMobile ? 'd-none' : ''}
          ${nextMonthButtonDisabled ? 'd-none' : ''}
        `,
      onClick: increaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowRight, {
      className: "icon"
    })));
  };
  const renderDayContents = (day, date) => /*#__PURE__*/React.createElement("span", {
    className: "react-datepicker__day-text"
  }, date.getDate());
  const generateDateObj = date => date ? {
    day: date.toLocaleString(undefined, {
      day: "numeric"
    }),
    dayNumber: date.toLocaleString(undefined, {
      day: "2-digit"
    }),
    month: date.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
      month: "long"
    }),
    monthNumber: date.toLocaleString('en-US', {
      month: "2-digit"
    }),
    year: date.toLocaleString(undefined, {
      year: "numeric"
    }),
    fullDate: date
  } : emptyDateShowObj;
  useEffect(() => {
    setDepDate && setDepDate(generateDateObj(singleDate));
  }, [singleDate]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    opened: dateOpened
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-close d-none d-md-block",
    onClick: closeDateDropdownWithAnalytics
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: closeDateDropdownWithAnalytics
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, dateMobileDateText)), /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body__head-wrapper d-none d-md-flex"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "datepicker-body__head"
  }, dateMobileDateText)), /*#__PURE__*/React.createElement(DatePicker, {
    inline: !!dateOpened,
    monthsShown: isMobile ? 10 : 1,
    locale: langHash[lang],
    renderCustomHeader: renderCustomHeader,
    selected: singleDate,
    minDate: new Date(),
    maxDate: addDays(new Date(), 299),
    renderDayContents: renderDayContents,
    onChange: date => {
      setSingleDate(date);
      changeWeatherDataHandler(date);
      closeDateDropdown();
    }
  })));
};
const commonStyles = "c1hp98uz";
const ltrStyles = "lj1r4ux";
const rtlStyles = "r1lwdciw";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    opened
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `
  datepicker-dropdown
  ${commonStyles}
  ${rtl ? rtlStyles : ltrStyles}
  ${opened ? 'datepicker-dropdown--opened' : ''}
`
  }, children);
};
export { DatePickerDropDown, getStringFullDate, getStringWeek, emptyDateShowObj };